import {Component, Input, OnChanges} from '@angular/core';
import {KfRegistration} from '../../../../shared/models/kf-registration.interface';
import {KfRegistrationDetail} from '../../../../kf-data-entry/models/kf-registration-detail.interface';
import {Master} from '../../../../admin/models/master.interface';

@Component({
  selector: 'app-kf-registration-validation-table',
  templateUrl: './kf-registration-validation-table.component.html',
  styleUrls: ['./kf-registration-validation-table.component.scss']
})
export class KfRegistrationValidationTableComponent implements OnChanges {

  @Input()
  kfRegistration!: KfRegistration;
  @Input()
  kfRegistrationDetail!: KfRegistrationDetail;
  @Input()
  categories!: Master[];

  displayedColumns: string[] = ['entry', 'pieces', 'tons', 'remark'];
  b2bFooter: string[] = ['b2bFooter', 'totalB2BPieces', 'totalB2BTons', 'remarkB2B'];
  b2cFooter: string[] = ['b2cFooter', 'totalB2CPieces', 'totalB2CTons', 'remarkB2C'];
  subTotalPiecesB2B = 0;
  subTotalTonsB2B = 0;
  subTotalPiecesB2C = 0;
  subTotalTonsB2C = 0;
  totalPieces = 0;
  totalTons = 0;

  constructor() { }

  ngOnChanges(): void {
    if (this.kfRegistrationDetail) {
      this.kfRegistrationDetail.categories.forEach(category => {
        if (category.kind.toString() == "B2B") {
          this.subTotalPiecesB2B += category.piecesValue || 0;
          this.subTotalTonsB2B += category.tonsValue || 0;
        }
        if (category.kind.toString() == "B2C") {
          this.subTotalPiecesB2C += category.piecesValue || 0;
          this.subTotalTonsB2C += category.tonsValue || 0;
        }
        this.totalPieces += category.piecesValue || 0;
        this.totalTons += category.tonsValue || 0;
      });
    }
  }

}
